
import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Row,
  Form,
  Label,
  Input,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap"
import { useTranslation } from "react-i18next"
import { is_empty, is_email } from "../../config/validate"

import { saveSupplierProfile, getSupplierProfile } from "../../store/actions"
import showToast from "../../components/Common/viewNotification"

const ProfileForm = ({ isOpen, toggle }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [dateIni, setDateIni] = useState({ value: "", error: "" })
  const [category, setCategory] = useState({ value: "", error: "" })
  const [contact, setContact] = useState({ value: "", error: "" })
  const [email, setEmail] = useState({ value: "", error: "" })
  const [phone, setPhone] = useState({ value: "", error: "" })
  const [cellphone, setCellphone] = useState({ value: "", error: "" })
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [edit, setEdit] = useState(false);

  let [errors, setErrors] = useState([])

  const onEdit = () => setEdit(!edit);

  const { loading, current, profile } = useSelector(state => {
    return ({
      loading: state.Concept.loadingSave,
      current: state.Dashboard.user,
      profile: state.Suppliers.supplierProfile
    })
  })

  useEffect(() => {
    if (current?.supplier?.id) {
      dispatch(getSupplierProfile(current?.supplier?.id))
    }
  }, [current])

  useEffect(() => {
    if (profile?.id) {
      fillFormFields(profile)
    } else {
      onEdit()
    }
  }, [profile])

  const fillFormFields = (supplier) => {
    setDateIni({ value: convertDate(supplier.dateIni) || "", error: "" });
    setCategory({ value: supplier.category || "", error: "" });
    setContact({ value: supplier.contact || "", error: "" });
    setEmail({ value: supplier.email || "", error: "" });
    setPhone({ value: supplier.phone || "", error: "" });
    setCellphone({ value: supplier.cellphone || "", error: "" });
  };

  const handleSubmit = () => {
    validate()
    if (errors.length === 0) {
      let values = {
        id: profile.id || null,
        dateIni: getNextDay(dateIni.value),
        category: category.value,
        contact: contact.value,
        email: email.value,
        phone: phone.value,
        cellphone: cellphone.value,
        createdBy: auth.id.user.username,
        status: 1,
        supplier: { id: current?.supplier?.id },
        society: current?.supplier?.society,
      }
      dispatch(saveSupplierProfile(values))
      showToast(current?.supplier?.name, "success", "Perfil Guardado")
      toggle()
    }
  }

  const getNextDay = (currentDay) => {
    const originalDate = new Date(currentDay);
    const nextDay = new Date(originalDate);
    nextDay.setDate(originalDate.getDate() + 1);
    return nextDay
  }

  const convertDate = (dateS) => {
    const isoDate = dateS
    const date = new Date(isoDate)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const formattedDate = `${year}-${month}-${day}`
    return formattedDate
  }

  const validate = () => {
    errors = []
    if (is_empty(email.value)) {
      email.error = t("error:required")
      errors.push(email.error)
    }
    if (!is_email(email.value)) {
      email.error = t("error:email")
      errors.push(email.error)
    }
    if (is_empty(contact.value)) {
      contact.error = t("error:required")
      errors.push(contact.error)
    }
    setErrors(errors)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <div className="text-primary fw-bold text-uppercase">
          {`Perfil ${current?.supplier?.name}`}
        </div>
      </ModalHeader>
      <ModalBody>
        {profile?.id && <div>
          <button
            type="button"
            onClick={onEdit}
            style={{
              background: "none",
              border: "none",
              color: "black",
              padding: 0,
              cursor: "pointer",
              float: "right"
            }}
          >
            <i className="fas fa-pen" />
          </button>
        </div>}
        <Form>
          <Row>
            <div style={profile?.id ? { padding: 0 } : {}}>
              <Label htmlFor="dateIni" className="d-block fw-bold font-size-16 text-secundary">{t("profile:dateIni")}:</Label>
              {!edit ? <Label className="d-block">{dateIni.value}</Label> :
                <Input
                  autoComplete="new-text"
                  type="date"
                  className="form-control"
                  value={dateIni.value || ""}
                  onChange={e => {
                    return setDateIni({ value: e.target.value, error: "" })
                  }}
                />}
            </div>
          </Row>
          <Row>
            <div>
              <Label className="d-block fw-bold font-size-16 text-secundary" htmlFor="category">{t("profile:category")}:</Label>
              {!edit ? <Label className="d-block">{category.value}</Label> :
                <Input
                  autoComplete="new-text"
                  type="text"
                  className="form-control"
                  value={category.value || ""}
                  onChange={e => {
                    setCategory({ value: e.target.value, error: "" })
                  }}
                />}
            </div>
          </Row>
          <Row>
            <div>
              <Label className="d-block fw-bold font-size-16 text-secundary" htmlFor="contact">{t("profile:contact")}*:</Label>
              {!edit ? <Label className="d-block">{contact.value}</Label> :
                <Input
                  autoComplete="new-text"
                  type="text"
                  className="form-control"
                  value={contact.value || ""}
                  onChange={e => {
                    setContact({ value: e.target.value, error: "" })
                  }}
                  invalid={!is_empty(contact.error)}
                />}
              <span className="small text-danger">{contact.error}</span>
            </div>
          </Row>
          <Row>
            <div>
              <Label className="d-block fw-bold font-size-16 text-secundary" htmlFor="email">{t("profile:email")}*:</Label>
              {!edit ? <Label className="d-block">{email.value}</Label> :
                <Input
                  autoComplete="new-text"
                  type="email"
                  className="form-control"
                  value={email.value || ""}
                  onChange={e => {
                    setEmail({ value: e.target.value, error: "" })
                  }}
                  invalid={!is_empty(email.error)}
                />}
              <span className="small text-danger">{email.error}</span>
            </div>
          </Row>
          <Row>
            <div>
              <Label className="d-block fw-bold font-size-16 text-secundary" htmlFor="phone">{t("profile:phone")}:</Label>
              {!edit ? <Label className="d-block">{phone.value}</Label> :
                <Input
                  autoComplete="new-text"
                  type="number"
                  className="form-control"
                  value={phone.value || ""}
                  onChange={e => {
                    setPhone({ value: e.target.value, error: "" })
                  }}
                />}
            </div>
          </Row>
          <Row>
            <div>
              <Label className="d-block fw-bold font-size-16 text-secundary" htmlFor="cellphone">{t("profile:cellphone")}:</Label>
              {!edit ? <Label>{cellphone.value}</Label> :
                <Input
                  autoComplete="new-text"
                  type="number"
                  className="form-control"
                  value={cellphone.value || ""}
                  onChange={e => {
                    setCellphone({ value: e.target.value, error: "" })
                  }}
                />}
            </div>
          </Row>
        </Form>
      </ModalBody>
      {edit &&
        <ModalFooter>
          <ButtonGroup>
            <button
              type="button"
              className="btn btn-info save-user"
              disabled={false}
              onClick={handleSubmit}
            >
              <i className=" fas fa-save me-1 " />
              {t("global:save")}
            </button>
            <button
              type="button"
              className="btn btn-danger "
              disabled={false}
              onClick={toggle}
            >
              {" "}
              {t("global:close")}
            </button>
          </ButtonGroup>
        </ModalFooter>}
    </Modal>

  )
}

export default ProfileForm
